import type { SVGProps } from "react";
const SvgNumber05 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill="none"
    fillRule="evenodd"
    stroke="black"
    strokeWidth={0.501}
    strokeLinejoin="bevel"
    strokeMiterlimit={10}
    fontFamily="Times New Roman"
    fontSize={16}
    style={{
      fontVariantLigatures: "none",
    }}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlns="http://www.w3.org/2000/svg"
    overflow="visible"
    width="40.244pt"
    height="73.827pt"
    viewBox="36.022 -208.96 40.244 73.827"
    {...props}
  >
    <defs />
    <g id="Board Elements" transform="scale(1 -1)">
      <g
        id="Group"
        fillRule="nonzero"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke="none"
        strokeWidth={0.416}
      >
        <g id="Group_1">
          <g id="Group_2">
            <g id="Group_3" fill="#262626">
              <g id="Group_4">
                <path
                  d="M 73.851,164.638 C 73.977,163.686 74.056,162.115 74.088,159.924 L 74.045,154.399 C 74.019,149.231 72.325,144.956 68.964,141.574 C 65.603,138.192 61.099,136.127 55.453,135.38 C 50.186,134.683 45.936,135.461 42.7,137.712 C 39.465,139.963 37.498,143.721 36.801,148.987 L 36.638,151.677 C 36.665,152.455 37.027,152.891 37.724,152.983 L 50.858,154.72 C 51.429,154.796 51.784,154.553 51.923,153.99 L 51.999,153.419 L 52.137,152.372 C 52.457,149.961 53.504,148.873 55.281,149.108 C 57.375,149.385 58.503,150.858 58.666,153.526 C 58.731,154.503 58.764,155.96 58.765,157.897 C 58.762,158.413 58.749,158.992 58.729,159.635 C 58.708,160.278 58.652,160.949 58.559,161.646 C 58.472,162.797 58.128,163.687 57.528,164.318 C 56.928,164.949 56.152,165.201 55.2,165.075 C 53.487,164.849 52.414,163.932 51.981,162.326 C 51.757,161.586 51.359,161.178 50.788,161.102 L 37.559,159.352 C 37.242,159.31 36.973,159.388 36.753,159.584 C 36.534,159.781 36.435,160.043 36.456,160.368 L 36.022,200.207 C 36.044,200.533 36.151,200.822 36.344,201.073 C 36.536,201.324 36.791,201.471 37.108,201.513 L 72.131,206.147 C 72.448,206.189 72.717,206.111 72.937,205.915 C 73.156,205.718 73.255,205.456 73.234,205.131 L 73.389,193.725 C 73.367,193.399 73.26,193.11 73.068,192.859 C 72.875,192.608 72.62,192.461 72.303,192.419 L 51.936,189.724 C 51.619,189.682 51.481,189.503 51.523,189.185 L 51.587,175.54 C 51.612,175.35 51.691,175.247 51.822,175.232 C 51.953,175.217 52.073,175.281 52.183,175.425 C 54.326,177.774 56.888,179.146 59.87,179.541 C 63.676,180.045 66.784,179.245 69.193,177.143 C 71.602,175.041 73.092,171.833 73.663,167.518 C 73.747,166.884 73.81,165.924 73.851,164.638 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
            <g id="Group_5" fill="#f7e5c5">
              <g id="Group_6">
                <path
                  d="M 76.029,167.44 C 76.155,166.488 76.234,164.917 76.266,162.726 L 76.223,157.201 C 76.197,152.033 74.503,147.758 71.142,144.376 C 67.781,140.994 63.277,138.929 57.631,138.182 C 52.364,137.485 48.114,138.263 44.878,140.514 C 41.643,142.765 39.676,146.523 38.979,151.789 L 38.816,154.479 C 38.843,155.257 39.205,155.692 39.902,155.785 L 53.036,157.522 C 53.607,157.598 53.962,157.355 54.101,156.792 L 54.177,156.221 L 54.315,155.174 C 54.635,152.763 55.682,151.675 57.459,151.91 C 59.553,152.187 60.681,153.66 60.844,156.328 C 60.909,157.305 60.942,158.762 60.943,160.699 C 60.94,161.215 60.927,161.794 60.907,162.437 C 60.886,163.08 60.83,163.751 60.737,164.448 C 60.65,165.599 60.306,166.489 59.706,167.12 C 59.106,167.751 58.33,168.003 57.378,167.877 C 55.665,167.651 54.592,166.734 54.159,165.128 C 53.935,164.388 53.537,163.98 52.966,163.904 L 39.737,162.154 C 39.42,162.112 39.151,162.19 38.931,162.386 C 38.712,162.583 38.613,162.845 38.634,163.17 L 38.2,203.009 C 38.222,203.335 38.329,203.624 38.522,203.875 C 38.714,204.126 38.969,204.273 39.286,204.315 L 74.309,208.949 C 74.626,208.991 74.895,208.913 75.115,208.717 C 75.334,208.52 75.433,208.258 75.412,207.933 L 75.567,196.527 C 75.545,196.201 75.438,195.912 75.246,195.661 C 75.053,195.41 74.798,195.263 74.481,195.221 L 54.114,192.526 C 53.797,192.484 53.659,192.305 53.701,191.987 L 53.765,178.342 C 53.79,178.152 53.869,178.049 54,178.034 C 54.131,178.019 54.251,178.083 54.361,178.227 C 56.504,180.576 59.066,181.948 62.048,182.343 C 65.854,182.847 68.962,182.047 71.371,179.945 C 73.78,177.843 75.27,174.635 75.841,170.32 C 75.925,169.686 75.988,168.726 76.029,167.44 Z"
                  markerStart="none"
                  markerEnd="none"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
export default SvgNumber05;
